import {Box, Typography, useTheme} from '@mui/material';
import {Link} from 'react-router-dom';

interface IProps {
	title: string;
	image: string;
	url?: string;
	state?: any;
	gradient?: boolean;
	className?: string;
}

export default function Banner({title, image, url, state, gradient, className}: IProps) {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.primary[800];
	if (url) {
		return <Link to={url} className="relative" state={state}>
			<img src={image} alt="" className="rounded h-auto w-full object-cover"/>
			{gradient && <Box style={{
				background: `linear-gradient(316.28deg, ${color} 33.21%, rgba(0, 0, 0, 0) 62.12%)`,
				mixBlendMode: 'multiply'
			}} className="w-full h-28 absolute top-0 left-0 rounded"></Box>}
			<Typography sx={{fontSize: (theme) => theme.typography.fontSize + 6}}
			            className="font-medium text-white absolute bottom-2 rtl:right-2 ltr:left-2">{title}</Typography>
		</Link>;
	} else {
		return <Box className="relative">
			<img src={image} alt="" className={`rounded h-auto w-full object-cover ${className}`}/>
			{gradient && <Box style={{
				background: `linear-gradient(316.28deg, ${color} 33.21%, rgba(0, 0, 0, 0) 62.12%)`,
				mixBlendMode: 'multiply'
			}} className="w-full h-28 absolute top-0 left-0 rounded"></Box>}
			<Typography sx={{fontSize: (theme) => theme.typography.fontSize + 6}}
			            className="font-medium text-white absolute bottom-2 rtl:right-2 ltr:left-2">{title}</Typography>
		</Box>;
	}
}
